// Run Manager is using our Forio Account
const runManagerAccount = {
  run: {
    account: 'steer-group',
    project: 'covlum',
    model: 'Innovate v20.vmfx',
    server: {
      host: 'api.forio.com',
    },
    files: {
      DefineScenarios: 'Define scenarios_clean_v3.xlsx',
      Export: 'Export1.xlsx',
      InitialValues: 'Initial_values.xlsx',
      Ctx2: 'Innovate v20.ctx2',
      parameters: 'parameters.xlsx',
      transport: 'transport.xlsx',
    },
  },
  strategy: 'always-new',
}

const scenarios = [
  {
    name: 'Scenario1',
    title: 'Cycles of lockdown',
    description:
      'There is no effective treatment or vaccine. The virus remains prevalent, returning in waves that lead to a repeating cycle of hard and soft lockdown. Social distancing rules reduce the carrying capacity on rail and bus to 10% and 20% of normal, and workplaces to 30% for the whole simulation period.',
    icon: '/static/img/udm/icon-car.png',
    lockdownChart: '/static/img/udm/LockdownChart-CoL.png',
    baselineId: 'scenario1',
    variable: {
      name: 'Scenario1',
      value: 1,
    },
  },
  {
    name: 'Scenario2',
    title: 'Adaptation',
    description:
      'There is no effective treatment or vaccine, but the virus is contained, and society learns to live with it while accepting some constraints, such as social distancing. Hard lockdown ends after 13 weeks. Social distancing rules relax somewhat after week 52.',
    icon: '/static/img/udm/icon-car.png',
    lockdownChart: '/static/img/udm/LockdownChart-Ada.png',
    baselineId: 'scenario2',
    variable: {
      name: 'Scenario2',
      value: 1,
    },
  },
  {
    name: 'Scenario3',
    title: 'Therapeutics',
    description:
      'Hard lockdown ends after 13 weeks. Effective treatments become available in the spring of 2021, significantly reducing the suffering caused by the virus and its mortality rate. Social distancing remains in place but, after the end of 2021, allowing more people on public transport and in workplaces.',
    icon: '/static/img/udm/icon-car.png',
    lockdownChart: '/static/img/udm/LockdownChart-Ther.png',
    baselineId: 'scenario3',
    variable: {
      name: 'Scenario3',
      value: 1,
    },
  },
  {
    name: 'Scenario4',
    title: 'Vaccine',
    description:
      'Hard lockdown ends after 13 weeks. Effective treatments become available in the spring of 2021 followed by an effective vaccine in the autumn; this allows all social distancing restrictions to be lifted from the end of 2021.',
    icon: '/static/img/udm/icon-car.png',
    lockdownChart: '/static/img/udm/LockdownChart-Vacc.png',
    baselineId: 'scenario4',
    variable: {
      name: 'Scenario4',
      value: 1,
    },
  },
]

const zoneCategories = [
  {
    name: 'ZZThe town',
    label: 'The town',
  },
  {
    name: 'ZZTown and local area',
    label: 'Town and local area',
  },
]

const zones = [
  {
    map: 'ZZThe town',
    name: 'ZZThe town',
    label: 'The town',
  },
  {
    map: 'ZZTown and local area',
    name: 'ZZTown and local area',
    label: 'Town and local area',
  },
]

// The output variables we are after
// Format options: http://numeraljs.com/#format
const outputs = [
  {
    name: 'Reduced TTW matrix by destination category',
    label: 'People travelling to workplaces',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'WFH trips by destination category',
    label: 'People working from home',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'Furloughed trips by destination category',
    label: 'People furloughed',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'WF unemployment rate by zone category',
    label: 'Unemployment rate',
    format: '0.0%',
    baselineComparisonFormat: '0.0',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: false,
    no_change_limit: 0.1,
  },
  {
    name: 'Effective GVA by zone category',
    label: 'GVA (£/year)',
    format: '$0,0.00a',
    baselineComparisonFormat: '$0,0.00a',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 1000000,
  },
  {
    name: 'BU vacancy rate by zone category',
    label: 'Commercial premises vacancy rate',
    format: '0.0%',
    baselineComparisonFormat: '0.0',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 0.1,
  },
  {
    name: 'Car ttw trips by destination categories',
    label: 'Travel to work trips per day by car',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'Rail ttw trips by destination categories',
    label: 'Travel to work trips per day by train',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'Bus ttw trips by destination category',
    label: 'Travel to work trips per day by bus',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'Walk ttw trips by destination categories',
    label: 'Travel to work trips per day by walk & cycle',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'Car non work trips by Dzone category',
    label: 'Personal travel by car (trips per day)',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'Rail non work trips by DZone category',
    label: 'Personal travel by train (trips per day)',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'bus non work trips by DZone category',
    label: 'Personal travel by bus (trips per day)',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'Walk non work trips by DZone category',
    label: 'Personal travel by walk & cycle (trips per day)',
    format: '0.0A',
    baselineComparisonFormat: '0.0A',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 100,
  },
  {
    name: 'Total daily bus revenue',
    label: 'Daily Bus Operator Revenue',
    format: '$0,0.0a',
    baselineComparisonFormat: '$0,0.0a',
    display_in_results: true,
    per_zone_category: true,
    higher_than_base_is_better: true,
    no_change_limit: 5000,
  },
  {
    name: 'Lockdown status',
    label: 'Lockdown',
    format: '0',
    baselineComparisonFormat: '0',
    display_in_results: false,
    per_zone_category: true,
    higher_than_base_is_better: true,
  },
  {
    name: 'Applied decelerator',
    label: 'Social distancing',
    format: '0',
    baselineComparisonFormat: '0',
    display_in_results: false,
    per_zone_category: true,
    higher_than_base_is_better: true,
  },
  {
    name: 'Actual public confidence',
    label: 'Public confidence',
    format: '0',
    baselineComparisonFormat: '0',
    display_in_results: false,
    per_zone_category: true,
    higher_than_base_is_better: true,
  },
]

const inputCategories = [{ name: 'Inputs', reference: 'PT' }]

// All the input variables and their initial value
const inputs = [
  {
    label: 'Reduce parking spaces',
    description:
      'This will reduce parking spaces for commuters in the town by {{Reduction in town parking spaces}}%',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Reduce parking spaces',
    category: 'PT',
  },
  {
    label: 'Increase safe bus capacity',
    description:
      'This will increase the safe carrying capacity of buses by {{Percent increase in safe bus capacity}}%.  It might be done by increased hygiene measures on the buses or running more buses or larger buses.',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Increase safe bus capacity',
    category: 'PT',
  },
  {
    label: 'Increase safe rail capacity',
    description:
      'This will increase the safe carrying capacity of trains by {{Percent increase in rail safe capacity}}%. It might be done by increased hygiene measures on the trains or running more trains or longer trains.',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Increase safe rail capacity',
    category: 'PT',
  },
  {
    label: 'Increase safe workplace capacity',
    description:
      'This will increase the safe capacity of workplaces by {{Percent increase in workplace capacity}}%. It might be done by improved hygiene measures in workplaces, allowing higher levels of occupancy.',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Increase safe workplace capacity',
    category: 'PT',
  },
  {
    label: 'Reduce bus fares',
    description:
      'This will reduce bus fares by {{Percentage reduction in bus fares}}%',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Reduce bus fares',
    category: 'PT',
  },
  {
    label: 'Reduce rail fares',
    description:
      'This will reduce rail fares by {{Percentage reduction in rail fares}}%',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Reduce rail fares',
    category: 'PT',
  },
  {
    label: 'Local improvements to walk and cycle',
    description:
      'This will make walk and cycle more attractive for travel to, from, and within the town.',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Local improvements to walk and cycle',
    category: 'PT',
  },
  {
    label: 'Open offices more days',
    description:
      'This spreads office opening hours over seven days. The result is a reduction in peak demand on each day, by a factor of {{Factor to reduce TTW trips per day}}',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Open offices more days',
    category: 'PT',
  },
  {
    label: 'Boost public confidence',
    description:
      'This assumes measures can be taken to improve confidence, making people more relaxed about increasing travel to pre-COVID levels.',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Boost public confidence',
    category: 'PT',
  },
  {
    label: 'Encourage shift to offpeak travel',
    description:
      'This will cause a shift of demand from the peak to the off-peak.',
    reference: 'PT1',
    oneoff: false,
    credit: 1,
    modelVariable: 'Encourage shift to offpeak travel',
    category: 'PT',
  },
]

const inputReplacements = [
  {
    name: 'Reduction in town parking spaces',
    replaceWith: '10',
  },
  {
    name: 'Percent increase in safe bus capacity',
    replaceWith: '100',
  },
  {
    name: 'Percent increase in rail safe capacity',
    replaceWith: '100',
  },
  {
    name: 'Percent increase in workplace capacity',
    replaceWith: '100',
  },
  {
    name: 'Percentage reduction in bus fares',
    replaceWith: '30',
  },
  {
    name: 'Percentage reduction in rail fares',
    replaceWith: '30',
  },
  {
    name: 'Factor to reduce TTW trips per day',
    replaceWith: '0.8',
  },
]

inputs.forEach((input, index) => {
  inputReplacements.forEach((replace) => {
    if (input.description.indexOf(replace.name) > -1) {
      const newInput = input
      newInput.description = input.description.replace(
        `{{${replace.name}}}`,
        replace.replaceWith,
      )
      inputs[index] = newInput
    }
  })
})

// We allow for 150 runs and run-to-end is literally all of those
const maxNumberOfRuns = 150
const runToEndFinishesAt = 150
const runStages = []

Array(maxNumberOfRuns + 1)
  .fill()
  .map((_, i) =>
    runStages.push({
      stepTo: 0.02 * (i + 1),
      label: `${i + 1}`,
    }),
  )

export default {
  runManagerAccount,
  zoneCategories,
  zones,
  scenarios,
  inputs,
  inputCategories,
  outputs,
  runStages,
  runToEndFinishesAt,
  maxNumberOfRuns,
}
